import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  allowAccessToLocationMessage: {
    id: `${scope}.allowAccessToLocationMessage`,
    defaultMessage: 'Please allow access to your device location to see your local businesses',
  },
  noRecommendedMessage: {
    id: `${scope}.noRecommendedMessage`,
    defaultMessage: "We didn't find any businesses that match your criteria. Please revisit your Preferences.",
  },
});
